export default __webpack_public_path__ + "static/1071-516a207da12f95377c67ac9faea503ed.gif";